import { useLocation } from 'react-router-dom';

import { LicenseTypeNature } from '../types';

import { SEPARATE_EPHYTO } from '../config';

function useLicenseTypeNature() {
  const location = useLocation();

  if (!SEPARATE_EPHYTO) {
    return undefined;
  }

  return location.pathname.startsWith('ephyto', 1) ? LicenseTypeNature.EPHYTO : LicenseTypeNature.LPCO;
}

export default useLicenseTypeNature;
